<div class="event-extra-information-viewer"
     [ngClass]="{'hide-data-capture-panel': !(eventFormConfigs && eventFormConfigs.length > 0) || !showDataCaptureSection}">
  <div class="disclaimer-for-reports" *ngIf="config?.showDisclaimer"><b> {{ 'NOTICE' | translate}} </b> {{ 'REPORTS_DISCLAIMER' | translate}}</div>
  <ispm-event-content-file-viewer
  [ngStyle]="{'width': config?.middlePanel?.width, 'padding-top': config.showDisclaimer ? '0.4%' : ''}"
          [ngClass]="{'full-width-height': !showDataCaptureSection}"
          [selectedEvent]="_selectedEvent"
          [isEditable]="isEventViewerEditable"
          [eventDefinition]="eventDefinition"
          [nlpConfig]="config.nlpConfiguration"
          [addReportAvailable]="addReportAvailable"
          [eventFileIdList]="eventFileIdList">
  </ispm-event-content-file-viewer>
  <ispm-event-dynamic-form-viewer
          *ngIf="(eventFormConfigs && eventFormConfigs.length > 0) && showDataCaptureSection"
          [ngStyle]="{'width': config?.rightPanel?.width}"
          [eventFormData]="eventFormData"
          [isEditable]="isEventViewerEditable"
          (onFormDataUpdated)="formDataUpdated($event)"
          [selectedEvent]="_selectedEvent"
          [eventDefinition]="eventDefinition"
          [eventFormConfigs]="eventFormConfigs">
  </ispm-event-dynamic-form-viewer>
  <!--showWizard will load conditionally when button is clicked, get this data from store-->
  <!--<section *ngIf = "!showWizard" class="event-actions-container"-->
 <section class="event-actions-container"
           [ngStyle]="{'width': config?.rightPanel?.width}">
    <span class="event-actions-left-side">
      <span *ngIf="isEditable && eventFormConfigs && eventFormConfigs.length; else addPacsLauncher" >
        <p-checkbox *ngIf="_selectedEvent && !enableSaveButton && isValidateAvailable"
                    checkboxIcon="{{checkboxIcon}}"
                    value="Validate event"
                    label="{{'VALIDATE_EVENT' | translate}}"
                    binary="true"
                    [ngClass]="!isApproveAvailable ?  'uncheck-button':'approve-button disabled'"
                    [disabled]="!isApproveAvailable"
                    (onChange)="onApproveEvent()"
                    [(ngModel)]="!isApproveAvailable">
        </p-checkbox>
        <ng-container *ngTemplateOutlet="addPacsLauncher"></ng-container>
        <gen-button
              *ngIf="showCopyToResource && isEditable && _selectedEvent && !enableSaveButton  && isCopyToTumourAvailable && eventDefinition?.ui.eventPanel?.controls.copy"
              [text]="eventDefinition?.ui.eventPanel?.controls.copy"
              [type]="'secondary'"
              (click)="onCopyToResource()">
        </gen-button>
        <gen-button
                *ngIf="isEditable && _selectedEvent && enableSaveButton && !showUpdateButton"
                [text]="'edit_tnm_save'"
                (click)="onUpdateFormData()">
        </gen-button>
      </span>
      <ng-template #addPacsLauncher>        
        <ispm-pacs-launcher class="button-pacs" *ngIf="showLaunchPacsInEventContent"
                [currentEvent]=_selectedEvent>
        </ispm-pacs-launcher>
      </ng-template>
    </span>
    <span class="event-actions-right-side">
      <gen-button
              *ngIf="isBackToDashboardAvailable"
              [text]="'Back To Dashboard'"
              (click)="onCloseReports()">
      </gen-button>
      <gen-button
              *ngIf="isEditable && _selectedEvent && showUpdateButton"
              [text]="'Update'"
              (click)="onUpdateValidateCopyFormData()">
        </gen-button>
    </span>
  </section>
</div>
